import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

export type RemoveSimpleTextSettingAction = FSA<undefined, number, string>
type RemoveSimpleTextSettingColor = (simpleTextSettingId: number) => MrxThunk<RemoveSimpleTextSettingAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'removeSimpleTextSetting', boolean>

const REMOVE_SIMPLE_TEXT_SETTING = `
  mutation removeSimpleTextSetting ($simpleTextSettingId: Int!) {
    removeSimpleTextSetting(simpleTextSettingId: $simpleTextSettingId)
  }
`

const removeSimpleTextSetting: RemoveSimpleTextSettingColor = (simpleTextSettingId) => async (dispatch) => {
  let isRemoved = false

  dispatch({
    type: t.REMOVE_SIMPLE_TEXT_SETTING,
    meta: { done: false }
  })

  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: REMOVE_SIMPLE_TEXT_SETTING,
      variables: { simpleTextSettingId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Empty response!')
    }

    const { removeSimpleTextSetting } = data
    if (!removeSimpleTextSetting) {
      throw new Error("Can't remove simpleText setting!")
    }

    dispatch({
      type: t.REMOVE_SIMPLE_TEXT_SETTING,
      payload: simpleTextSettingId,
      meta: { done: true }
    })

    isRemoved = true
  } catch (err) {
    dispatch({
      type: t.REMOVE_SIMPLE_TEXT_SETTING,
      payload: extractErrorInfo(err),
      error: true
    })
  }

  return isRemoved
}

export { removeSimpleTextSetting }
